export default __webpack_public_path__ + "static/media/santa-texting.2afe8832.jpg";